module.exports = __webpack_public_path__ + "static/assets/c8481ea8e104d4d2bb6b340e0c90da26.svg";